import axios from "axios";
import { baseUrl } from "../config/api-config";

export async function createTeamsMeeting(body, token, teamsToken) {
  try {
    const { data } = await axios.post(
      `${baseUrl}/employeeperformance/teams/schedulemeeting`,
      body,
      {
        headers: {
          authorization: token,
          "x-ms-token": teamsToken,
        },
      }
    );

    // token was not expired
    if (data.status) {
      return { error: false };
    } else {
      // token was expired so made another request with new token
      await axios.post(
        `${baseUrl}/employeeperformance/teams/schedulemeeting`,
        body,
        {
          headers: {
            authorization: token,
            "x-ms-token": data.msTeamsAuth,
          },
        }
      );

      return { error: false };
    }
  } catch (error) {
    return { error };
  }
}
